import { render, staticRenderFns } from "./birimhedefgirisoranlaritablosu.vue?vue&type=template&id=037ad8ef"
import script from "./birimhedefgirisoranlaritablosu.vue?vue&type=script&lang=js"
export * from "./birimhedefgirisoranlaritablosu.vue?vue&type=script&lang=js"
import style0 from "./birimhedefgirisoranlaritablosu.vue?vue&type=style&index=0&id=037ad8ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports